import { Menu } from 'lucide-react';

import { useNavigationStore } from '@/stores/navigation';

import type { ReactNode } from 'react';

const titleStyle = { fontFamily: 'var(--font-display, Unbounded)' };

export function MobileHeader(): ReactNode {
  const setMobileMenu = useNavigationStore((s) => s.setMobileMenu);

  return (
    <header
      style={{
        background: 'var(--surface)',
        borderColor: 'var(--border-subtle)',
      }}
      className="flex md:hidden items-center h-14 px-4 border-b"
    >
      <button
        onClick={() => setMobileMenu(true)}
        style={{ color: 'var(--text-muted)' }}
        className="p-2 -ml-2"
      >
        <Menu className="w-5 h-5" />
      </button>
      <span style={titleStyle} className="ml-2 text-sm font-semibold">
        Social Assistant
      </span>
    </header>
  );
}
